import { useEffect } from "react";
import updateWorkflowState from "@/utils/client/setWorkflowState";

export default function useSetWorkflowState(workflowId: number, state: JSON) {
  useEffect(() => {
    console.log("useSetWorkflowState", workflowId, state);
    const run = async () => {
      await updateWorkflowState(workflowId, state);
    };
    run();
    return function cleanup() {
      return;
    };
  }, [workflowId, state]);
}
